var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loaded
      ? _c(
          "div",
          [
            _c("app-nav"),
            _vm._v(" "),
            _vm.doctor && !_vm.doctor.isCertified
              ? _c(
                  "div",
                  {
                    staticClass: "is-hidden-mobile hero is-blue-dark py-3",
                    attrs: { id: "certification-banner" }
                  },
                  [
                    _c("div", { staticClass: "container" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "has-text-centered has-text-weight-semibold is-size-6"
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "has-icon" },
                            [
                              _c("b-icon", { attrs: { icon: "alert" } }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("doctor_not_certified_warning")
                                  ) +
                                  "\n                    "
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "main",
              {
                staticClass: "is-hidden-mobile mb-7",
                staticStyle: { position: "relative" }
              },
              [
                _c("router-view"),
                _vm._v(" "),
                _vm.notifications.length
                  ? _c(
                      "div",
                      { staticClass: "notifications-wrapper" },
                      _vm._l(_vm.notifications, function(notification) {
                        return _c(
                          "div",
                          {
                            key: notification.id,
                            staticClass: "notification clickable",
                            class: notification.type,
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.showEmergency(
                                  notification.appointment
                                )
                              }
                            }
                          },
                          [
                            _c("button", {
                              staticClass: "delete",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.disableNotification(notification)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "media" }, [
                              _c("div", {
                                staticClass: "media-content",
                                domProps: {
                                  innerHTML: _vm._s(notification.content)
                                }
                              })
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                Object.keys(_vm.currentEmergency).length > 0
                  ? _c("emergency-modal", {
                      attrs: {
                        active: _vm.showEmergencyModal,
                        emergency: _vm.currentEmergency,
                        availability: _vm.currentAvailability
                      },
                      on: {
                        close: function($event) {
                          return _vm.closeEmergencyModal()
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("main", { staticClass: "is-hidden-tablet" }, [
              _c(
                "div",
                {
                  staticClass:
                    "has-text-centered has-text-weight-semibold is-size-6 mt-8 mx-4"
                },
                [
                  _c("p", [_vm._v(_vm._s(_vm.$t("app_message_on_mobile")))]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "mt-8",
                    staticStyle: { width: "90px" },
                    attrs: {
                      src: "/static/img/tood.png",
                      alt: "Tooddoc Mascot"
                    }
                  })
                ]
              )
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-048072c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-048072c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/App.vue
// module id = 615
// module chunks = 1